var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewConnectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0802 0.452422C11.2715 0.315827 11.5283 0.315827 11.7196 0.452422L21.9196 7.73814C22.0641 7.84138 22.1499 8.00807 22.1499 8.18569V17.9C22.1499 18.2037 21.9037 18.45 21.5999 18.45C21.2961 18.45 21.0499 18.2037 21.0499 17.9V8.46873L11.3999 1.57587L1.7499 8.46873V20.75H9.8999C10.2037 20.75 10.4499 20.9962 10.4499 21.3C10.4499 21.6037 10.2037 21.85 9.8999 21.85H1.1999C0.896146 21.85 0.649902 21.6037 0.649902 21.3V8.18569C0.649902 8.00807 0.735683 7.84138 0.880221 7.73814L11.0802 0.452422Z",
    fill: "#383634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.55 17.45V22.45H22C22.3037 22.45 22.55 22.6963 22.55 23C22.55 23.3038 22.3037 23.55 22 23.55H13C12.6962 23.55 12.45 23.3038 12.45 23V17.45H13.55Z",
    fill: "#383634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.45001C11.8037 8.45001 12.05 8.69626 12.05 9.00001V10.7H13.95V9.00001C13.95 8.69626 14.1962 8.45001 14.5 8.45001C14.8037 8.45001 15.05 8.69626 15.05 9.00001V10.7H15.9C16.2589 10.7 16.55 10.991 16.55 11.35V14.1466C16.55 16.1466 14.978 17.8 13 17.8C11.0219 17.8 9.44995 16.1466 9.44995 14.1466V11.35C9.44995 10.991 9.74097 10.7 10.1 10.7H10.95V9.00001C10.95 8.69626 11.1962 8.45001 11.5 8.45001ZM10.55 11.8V14.1466C10.55 15.5745 11.6643 16.7 13 16.7C14.3356 16.7 15.45 15.5745 15.45 14.1466V11.8H10.55Z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewConnectionIcon);
export default __webpack_public_path__ + "static/media/new_connection_icon.db745d7439526e38c4c7f04cecfd533a.svg";
export { ForwardRef as ReactComponent };